<template>
    <div id="dashNotificationReel" class="ui inverted list" @wheel.stop>

      <h4 class="ui header" style="color:#fff;" v-show="$parent.$parent.worldStore.notifications.length>0">
        <span class="ui violet empty circular label"></span>
        Recent Notifications:
        <a @click.prevent="clearList"
          style="cursor:pointer; float:right; font-weight:normal; font-size:12px;">
          [clear list]
        </a>
      </h4>

      <!-- Geri, itt majd kell egy id a 'key'-nek, ha akarunk olyat h egyesevel is lehessen hidolni
            az elemeket. productId-je nem minden alertnek van uh azt nem raktam be erre -->
      <a v-for='item,index in $parent.$parent.worldStore.notifications'
            :key="index"
            class="item"
            @click="openDetails(index)">
        <img v-if="item.productId!==null && $parent.$parent.worldStore.products[item.productId]" class="ui mini image" :src="$parent.$parent.worldStore.products[item.productId].largeImageUrl" />
        <div class="content">
          <div :class="'header ' + item.notificationLevel">{{item.notificationType}}</div>
          <div class="description">{{item.message}}</div>
        </div>
      </a>

      <div v-show="$parent.$parent.worldStore.notifications.length == 0" style="color:#aaa;">
        Leave the site open, the latest <span class="ALERT">Alerts</span> <br> and <span class="NOTICE">Notifications</span> will appear here too.
      </div>
    </div>
</template>

<script>
// import $ from 'jquery'
export default {
  name: 'notificationReel',
  // components: {},
  // data: function () {return {}},
  methods: {
    openDetails: function (index) {
      if (this.$parent.$parent.worldStore.notifications[index].productId) {
        this.$parent.openProductDetailModal([this.$parent.$parent.worldStore.notifications[index].productId], 0)
      }
    },
    clearList: function () {
      this.$parent.$parent.worldStore.notifications = []
    },
  },
  // mounted: function (e) {},
}
</script>

<style>

#dashNotificationReel {
position: absolute; bottom: 3px; right: 100px; z-index: 3;
background-color:rgba(0,0,0,.5); padding:7px; border-radius: 7px;
max-height: 80vh; overflow-y: auto;
}
#dashNotificationReel .ALERT   {color:#d43;}
#dashNotificationReel .WARNING {color:#f2711c}
#dashNotificationReel .NOTICE  {color:#4d3;}
#dashNotificationReel .item .description {width: 25vw;}

#dashNotificationReel .item:hover {background-color: rgba(0,0,0,.5);}
#dashNotificationReel .item:hover .description{color: white;}

</style>



// WEBPACK FOOTER //
// NotificationReel.vue?7679bb84